import {createMandatoryContext, Handler} from '../../../libs/shared/helpers/src/react/reactHelpers';
import {SearchTagsModel} from '../../models/api/searchTagModel';
import {SingleTagCreationEntryPointsEnum} from '../../services/tracking';

/*
 * Props.
 */

export interface SettingsTagsContextProps {
  requestTags: (
    url: string,
    canBeCancelled: boolean,
    shouldForceRefresh?: boolean,
  ) => Promise<SearchTagsModel | undefined>;
  clearTagsCache: Handler;
  singleTagCreationEntryPoint?: SingleTagCreationEntryPointsEnum;
}

/*
 * Context.
 */

export const [SettingsTagsContext, useSettingsTagsContext] =
  createMandatoryContext<SettingsTagsContextProps>();
